import iqraHero from "@/assets/media/iqra-hero.mp4";
import iqraHeroSmall from "@/assets/media/iqra-hero-sm.mp4";
import iqraHeroPoster from "@/assets/media/iqra-hero-poster.webp";
import iqraSession from "@/assets/media/iqra-session.mp4";
import iqraSessionSmall from "@/assets/media/iqra-session-sm.mp4";
import iqraSessionPoster from "@/assets/media/iqra-session-poster.webp";
import iqraHow from "@/assets/media/iqra-how.mp4";
import iqraHowPoster from "@/assets/media/iqra-how-poster.webp";
import iqraPath from "@/assets/media/iqra-path.mp4";
import iqraPathSmall from "@/assets/media/iqra-path-sm.mp4";
import iqraPathPoster from "@/assets/media/iqra-path-poster.webp";
import iqraMobileSession from "@/assets/media/iqra-m-session.mp4";
import iqraMobileSessionPoster from "@/assets/media/iqra-m-session-poster.webp";
import iqraMobileHero from "@/assets/media/iqra-m-hero.webp";
import iqraLetters from "@/assets/media/iqra-letters.webp";
import iqraTeacher from "@/assets/media/iqra-teacher.webp";
import iqraGuidance from "@/assets/media/iqra-guidance.webp";

import alwaniHero from "@/assets/media/alwani-hero.mp4";
import alwaniHeroSmall from "@/assets/media/alwani-hero-sm.mp4";
import alwaniHeroPoster from "@/assets/media/alwani-hero-poster.webp";
import alwaniStory from "@/assets/media/alwani-story.mp4";
import alwaniStorySmall from "@/assets/media/alwani-story-sm.mp4";
import alwaniStoryPoster from "@/assets/media/alwani-story-poster.webp";
import alwaniMap from "@/assets/media/alwani-map.mp4";
import alwaniMapPoster from "@/assets/media/alwani-map-poster.webp";
import alwaniBooking from "@/assets/media/alwani-booking.mp4";
import alwaniBookingPoster from "@/assets/media/alwani-booking-poster.webp";
import alwaniMobileScroll from "@/assets/media/alwani-m-scroll.mp4";
import alwaniMobileScrollPoster from "@/assets/media/alwani-m-scroll-poster.webp";
import alwaniShop from "@/assets/media/alwani-shop.webp";
import alwaniTour from "@/assets/media/alwani-tour.webp";
import alwaniTransfers from "@/assets/media/alwani-transfers.webp";
import alwaniMobileTour from "@/assets/media/alwani-m-tour.webp";
import dmcHero from "@/assets/media/dmc-hero.mp4";
import dmcHeroSmall from "@/assets/media/dmc-hero-sm.mp4";
import dmcHeroPoster from "@/assets/media/dmc-hero-poster.webp";
import dmcExpand from "@/assets/media/dmc-expand.mp4";
import dmcExpandSmall from "@/assets/media/dmc-expand-sm.mp4";
import dmcExpandPoster from "@/assets/media/dmc-expand-poster.webp";
import dmcMap from "@/assets/media/dmc-map.mp4";
import dmcMapSmall from "@/assets/media/dmc-map-sm.mp4";
import dmcMapPoster from "@/assets/media/dmc-map-poster.webp";
import dmcGround from "@/assets/media/dmc-ground.webp";
import dmcProcess from "@/assets/media/dmc-process.webp";
import dmcReviews from "@/assets/media/dmc-reviews.webp";
import dmcBrief from "@/assets/media/dmc-brief.webp";
import dmcMobileHero from "@/assets/media/dmc-m-hero.webp";
import dmcMobileThai from "@/assets/media/dmc-m-th.webp";
import dbz1Video from "@/assets/media/dbz-1.mp4";
import dbz1Poster from "@/assets/media/dbz-1-poster.webp";
import dbz2 from "@/assets/media/dbz-2.webp";
import dbz3 from "@/assets/media/dbz-3.webp";
import dbz4 from "@/assets/media/dbz-4.webp";
import robox1 from "@/assets/media/robox-1.webp";
import robox2 from "@/assets/media/robox-2.webp";
import robox3 from "@/assets/media/robox-3.webp";
import robox4 from "@/assets/media/robox-4.webp";
import robox5 from "@/assets/media/robox-5.webp";
import robox6 from "@/assets/media/robox-6.webp";
import robox7 from "@/assets/media/robox-7.webp";
import alphardHero from "@/assets/media/alphard-hero.mp4";
import alphardHeroSmall from "@/assets/media/alphard-hero-sm.mp4";
import alphardHeroPoster from "@/assets/media/alphard-hero-poster.webp";
import alphardStepIn from "@/assets/media/alphard-stepin.mp4";
import alphardStepInSmall from "@/assets/media/alphard-stepin-sm.mp4";
import alphardStepInPoster from "@/assets/media/alphard-stepin-poster.webp";
import alphardIsland from "@/assets/media/alphard-island.mp4";
import alphardIslandSmall from "@/assets/media/alphard-island-sm.mp4";
import alphardIslandPoster from "@/assets/media/alphard-island-poster.webp";
import alphardFares from "@/assets/media/alphard-fares.mp4";
import alphardFaresPoster from "@/assets/media/alphard-fares-poster.webp";
import alphardBook from "@/assets/media/alphard-book.mp4";
import alphardBookPoster from "@/assets/media/alphard-book-poster.webp";
import alphardMobileHero from "@/assets/media/alphard-m-hero.mp4";
import alphardMobileHeroPoster from "@/assets/media/alphard-m-hero-poster.webp";
import alphardMobileFaresThai from "@/assets/media/alphard-m-fares-th.webp";
import alphardModels from "@/assets/media/alphard-models.webp";
import alphardFooter from "@/assets/media/alphard-footer.webp";

import certDegree from "@/assets/media/cert-degree.webp";
import certGrade0 from "@/assets/media/cert-grade-0.webp";
import certGrade1 from "@/assets/media/cert-grade-1.webp";
import certHack0 from "@/assets/media/cert-hack-0.webp";
import certHack1 from "@/assets/media/cert-hack-1.webp";
import certHack2 from "@/assets/media/cert-hack-2.webp";
import certShopee from "@/assets/media/cert-shopee-code-league-2022.webp";
import certKafka from "@/assets/media/cert-kafka-udemy.webp";
import certTimo from "@/assets/media/cert-timo.webp";
import certUkmt from "@/assets/media/cert-ukmt.webp";
import certGacc from "@/assets/media/cert-gacc.webp";
import certIgcse from "@/assets/media/cert-igcse.webp";
import certEdexel from "@/assets/media/cert-edexel.webp";
import certDegreeThumb from "@/assets/media/cert-degree-thumb.webp";
import certGrade0Thumb from "@/assets/media/cert-grade-0-thumb.webp";
import certGrade1Thumb from "@/assets/media/cert-grade-1-thumb.webp";
import certHack0Thumb from "@/assets/media/cert-hack-0-thumb.webp";
import certHack1Thumb from "@/assets/media/cert-hack-1-thumb.webp";
import certHack2Thumb from "@/assets/media/cert-hack-2-thumb.webp";
import certShopeeThumb from "@/assets/media/cert-shopee-code-league-2022-thumb.webp";
import certKafkaThumb from "@/assets/media/cert-kafka-udemy-thumb.webp";
import certTimoThumb from "@/assets/media/cert-timo-thumb.webp";
import certUkmtThumb from "@/assets/media/cert-ukmt-thumb.webp";
import certGaccThumb from "@/assets/media/cert-gacc-thumb.webp";
import certIgcseThumb from "@/assets/media/cert-igcse-thumb.webp";
import certEdexelThumb from "@/assets/media/cert-edexel-thumb.webp";

export const person = {
  name: "Shah Faisal Wani",
  short: "Faisal Wani",
  role: "Research engineer at SCB DataX",
  email: "shahfaisalwani14@gmail.com",
};

export const socials = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/faisalw14" },
  { label: "GitHub", href: "https://github.com/ShahFaisalWani" },
  { label: "Medium", href: "https://medium.com/@shahfaisalwani14" },
] as const;

/* ---------------------------------------------------------------- Work */

export type Experience = {
  id: string;
  role: string;
  company: string;
  period: string;
  logo: string;
  href?: string;
  /* link text, "Visit {company}" when omitted */
  linkLabel?: string;
  summary: string;
  highlights: string[];
  stack: string[];
};

/* Same order as the resume. */
export const experiences: Experience[] = [
  {
    id: "datax",
    role: "Research Engineer",
    company: "SCB DataX",
    period: "2026 - Now",
    logo: "/logos/scbdatax.png",
    href: "https://arxiv.org/abs/2609.14991",
    linkLabel: "Read the Typhoon ASR paper",
    summary: "Real-time Thai speech recognition, and the evaluation and monitoring that take a bank’s voice agent to production.",
    highlights: [
      "Co-authored the Typhoon ASR Streaming paper on real-time Thai speech recognition, with 4.5× fewer errors than the full-context baseline, and built the FastAPI and WebSocket service that serves the model.",
      "Built the evaluation harness for a bank’s five-service voice AI agent: it scores real conversations end to end with LLM-as-a-Judge (DeepEval), and other teams run their own test sets through its API.",
      "Instrumented the agent with OpenTelemetry across Python, Go and Java services, with a Langfuse and ClickHouse dashboard for quality, latency, cost and safety on live traffic.",
      "Hardened it for the bank’s security review (Entra ID single sign-on, group-based access, managed identity instead of API keys, PII access logging) and shipped it to AKS through the bank’s Jenkins and Helm pipeline.",
      "Turned the Linguist team’s annotation platform into a multi-project speech-data pipeline and used it to prepare a Thai ASR benchmark.",
    ],
    stack: ["FastAPI", "DeepEval", "Langfuse", "OpenTelemetry", "Azure AKS"],
  },
  {
    id: "scb10x",
    role: "Full Stack Software Engineer",
    company: "SCB 10X",
    period: "2025 - 2026",
    logo: "/logos/scb10x.png",
    href: "https://playground.opentyphoon.ai",
    linkLabel: "Open Typhoon Playground",
    summary: "Shipped the public Typhoon Playground and the APIs behind Typhoon’s Thai OCR and speech models.",
    highlights: [
      "Shipped the public Typhoon Playground in Next.js: developers try the Thai OCR and real-time Thai and Isan speech recognition models live, then copy the generated SDK code into their apps.",
      "Added an OpenAI-compatible speech-to-text endpoint and a document OCR API to the FastAPI gateway serving Typhoon’s vLLM-hosted models on GCP.",
      "Integrated Datadog LLM Observability into the public Typhoon API and added per-user ASR usage tracking.",
      "Refactored the Linguist team’s NestJS and Next.js speech-annotation platform with Redis caching, reviewer analytics and multi-dialect support for regional Thai speech.",
    ],
    stack: ["Next.js", "FastAPI", "vLLM", "GCP", "Datadog"],
  },
  {
    id: "iqra",
    role: "Founder and AI Engineer",
    company: "Iqra AI",
    period: "2026 - Now",
    logo: "/logos/iqra.webp",
    href: "https://iqra-teacher.vercel.app",
    summary: "A real-time voice tutor that teaches Quran recitation sound by sound, built and run solo.",
    highlights: [
      "Took it to production on LiveKit: the tutor grades recitation sound by sound across a 66-lesson curriculum, from the Arabic alphabet to tajweed.",
      "Fine-tuned wav2vec 2.0 (XLS-R 300M) into a Quranic Arabic phoneme recognizer at 8.9% phoneme error rate, beating the ~9.5% published on the same data.",
      "Designed a scripture guardrail so the LLM teacher cannot misquote the Quran: it cites verses by reference and the engine inserts verified text and human recitation.",
    ],
    stack: ["LiveKit", "wav2vec 2.0", "Modal", "Next.js"],
  },
  {
    id: "mojen",
    role: "Co-founder and Developer",
    company: "Mojen.ai",
    period: "2024 - Now",
    logo: "/logos/mojen.png",
    href: "https://mojen.ai/",
    summary: "Co-founded and built an AI-driven platform that now has a real user base and revenue.",
    highlights: [
      "Built the platform from the ground up with my co-founder.",
      "Drove 33% weekly active user growth through iterative product and platform improvements.",
      "Designed and maintained the Docker and AWS infrastructure, cutting operating costs by 30%.",
      "Now part-time, giving technical direction while the platform runs largely on its own.",
    ],
    stack: ["AWS", "Docker", "AI features"],
  },
  {
    id: "scg",
    role: "Full Stack Developer, internship",
    company: "SCG",
    period: "2025",
    logo: "/logos/scg.png",
    summary: "Built an internal payroll system during a four-month internship.",
    highlights: [
      "Automated administrative workflows and salary payments, with secure transaction handling, audit trails and data protection.",
    ],
    stack: ["Full stack", "Payroll"],
  },
  {
    id: "alwani",
    role: "Full Stack Engineer, part-time",
    company: "Alwani Travel",
    period: "2023 - Now",
    logo: "/logos/alwani.png",
    href: "https://www.alwanitravel.com",
    summary: "The travel agency’s only engineer, from its booking site to its B2B site for travel agents.",
    highlights: [
      "Built alwanitravel.com in React, Strapi and Stripe in 2023, then rebuilt it in 2026 on Next.js, NestJS and PostgreSQL.",
      "Shipped a Claude tool-use importer that turns a supplier’s page, image or text into a tour draft for the admin to review.",
      "Put Omise and PayPal behind one payment interface, so every decline, retry and late 3-D Secure approval settles into a single order.",
      "Run delivery through a Claude Code multi-agent workflow with verification gates, about 350 tasks shipped in seven months.",
    ],
    stack: ["Next.js", "NestJS", "PostgreSQL", "Claude API"],
  },
  {
    id: "booktree",
    role: "Full Stack Developer, freelance",
    company: "Booktree",
    period: "2023",
    logo: "/logos/booktree.png",
    summary: "Built a bookstore management system and POS from scratch with the client.",
    highlights: [
      "Turned the client’s goals into specs, then built the store system in React.",
      "Built a REST API and POS that made transactions 50% faster.",
      "Stock management cut inventory errors and costs by 40%.",
      "Automated CI/CD with GitHub Actions and DigitalOcean.",
    ],
    stack: ["React", "REST API", "GitHub Actions", "DigitalOcean"],
  },
];

/* ------------------------------------------------------------ Projects */

/*
  w and h are the intrinsic pixel size, so frames keep the real aspect ratio.
  "wide" media get a full-width row on the case study page. focus is the
  object-position used when the media is cropped (cards, case study hero).
  Recordings shown full width (covers, wide rows) are 2x retina captures,
  2880 wide; small is the 1440 copy that phones and 1x screens get instead.
  posterAt is where in the clip (seconds) the poster frame was taken: playback
  starts there, so the poster hands off to the video without a jump.
*/
export type Media = { alt: string; w: number; h: number; span?: "wide"; focus?: string } & (
  | { kind: "image"; src: string }
  | { kind: "video"; src: string; small?: string; poster: string; posterAt?: number }
);

export type Project = {
  id: "iqra" | "alwani" | "dmc" | "robox" | "dbz" | "alphard";
  title: string;
  kicker: string;
  year?: string;
  role?: string;
  summary: string;
  details: string[];
  stack: string[];
  /* first one is the primary link (live site or write-up) */
  links: { label: string; href: string }[];
  /* up to two real figures shown on the deck card */
  stats?: { value: string; label: string }[];
  /* featured projects make up the deck on the home page; the rest are earlier builds */
  featured?: boolean;
  cover: Media;
  gallery: Media[];
};

export const projects: Project[] = [
  {
    id: "iqra",
    title: "Iqra AI",
    kicker: "AI voice tutor",
    year: "2026",
    role: "Founder, solo build",
    featured: true,
    summary:
      "A real-time voice tutor for Quran recitation. It listens while you recite, grades every sound, and tells you where in the mouth or throat a missed sound is made.",
    stats: [
      { value: "8.9%", label: "phoneme error rate, under the 9.5% published on the same data" },
      { value: "66", label: "lessons, from the Arabic alphabet to tajweed" },
    ],
    details: [
      "Built it solo and took it to production: a real-time voice tutor on LiveKit that grades recitation sound by sound across a 66-lesson curriculum.",
      "Fine-tuned wav2vec 2.0 (XLS-R 300M) into a Quranic Arabic phoneme recognizer at 8.9% phoneme error rate, beating the ~9.5% published on the same data. It grades every vowel the app hears.",
      "Benchmarked it on mispronunciation detection (the IqraEval protocol) and found the 8.9% hid a 19% catch rate on vowel-length errors. That benchmark now gates every new model before deployment.",
      "Split each voice turn in two: streaming speech-to-text only interprets the learner, and in-house grading models on Modal GPUs judge the sounds, because off-the-shelf transcribers correct the very errors a tutor must catch.",
      "Designed a scripture guardrail so the LLM teacher cannot misquote the Quran: it cites verses by reference, the engine inserts verified text and human recitation, and any other Arabic is stripped and regenerated.",
    ],
    stack: ["LiveKit", "wav2vec 2.0", "Modal", "Next.js", "Supabase"],
    links: [{ label: "Try Iqra", href: "https://iqra-teacher.vercel.app" }],
    cover: { kind: "video", src: iqraHero, small: iqraHeroSmall, poster: iqraHeroPoster, posterAt: 2.7, alt: "Iqra landing page with the chrome crescent and star", w: 2880, h: 1800, focus: "30% 0%" },
    gallery: [
      { kind: "video", src: iqraSession, small: iqraSessionSmall, poster: iqraSessionPoster, posterAt: 19.4, alt: "A demo lesson: the teacher speaks, the learner recites, then the correction", w: 2880, h: 1800, span: "wide" },
      { kind: "video", src: iqraHow, poster: iqraHowPoster, posterAt: 6, alt: "How it works: the verse, a live waveform and where the sound is made", w: 1920, h: 1200 },
      { kind: "image", src: iqraLetters, alt: "Every letter mapped to the place it comes from", w: 1920, h: 1200 },
      { kind: "image", src: iqraMobileHero, alt: "The landing page on a phone", w: 780, h: 1688 },
      { kind: "video", src: iqraMobileSession, poster: iqraMobileSessionPoster, posterAt: 5.1, alt: "The demo lesson on a phone", w: 780, h: 1688 },
      { kind: "video", src: iqraPath, small: iqraPathSmall, poster: iqraPathPoster, posterAt: 8, alt: "The curriculum path, from Qaida to Mastery", w: 2880, h: 1800, span: "wide" },
      { kind: "image", src: iqraTeacher, alt: "A teacher with a curriculum: letter drills and corrections", w: 1920, h: 1200 },
      { kind: "image", src: iqraGuidance, alt: "The crescent and the star, the teacher and the learner", w: 1920, h: 1200 },
    ],
  },
  {
    id: "alwani",
    title: "Alwani Travel",
    kicker: "Tour booking platform",
    year: "2026",
    role: "Sole engineer",
    featured: true,
    summary:
      "The booking platform of a licensed Phuket travel agency: tours, tickets and transfers from search to checkout, rebuilt in 2026 on Next.js, NestJS and PostgreSQL.",
    stats: [
      { value: "~80", label: "tours, tickets and transfers on sale" },
      { value: "350", label: "tasks shipped in seven months through a multi-agent workflow" },
    ],
    details: [
      "Built alwanitravel.com as the company’s only engineer: first in React and Strapi with Stripe in 2023, then rebuilt in 2026 as a Next.js, NestJS and PostgreSQL platform that runs the whole catalogue and every booking.",
      "Shipped a Claude tool-use importer that turns a supplier’s web page, image or text into a structured tour draft, which the non-technical admin reviews before it goes live.",
      "Put Omise and PayPal behind one payment-provider interface, so declines, retries and late 3-D Secure approvals all settle into a single order, and refunds follow one cancellation policy.",
      "Automated my own delivery with a Claude Code multi-agent workflow: a file-based task queue, agents sized to each task and verification gates before every commit, about 350 tasks shipped in seven months.",
    ],
    stack: ["Next.js", "NestJS", "PostgreSQL", "Claude API", "Omise", "PayPal"],
    links: [{ label: "Visit alwanitravel.com", href: "https://www.alwanitravel.com" }],
    cover: { kind: "video", src: alwaniHero, small: alwaniHeroSmall, poster: alwaniHeroPoster, posterAt: 1, alt: "Alwani Travel home page with a speedboat video behind the search", w: 2880, h: 1800, focus: "0% 0%" },
    gallery: [
      { kind: "video", src: alwaniStory, small: alwaniStorySmall, poster: alwaniStoryPoster, posterAt: 4.9, alt: "A day trip told as a pinned scroll story, stop by stop", w: 2880, h: 1800, span: "wide" },
      { kind: "image", src: alwaniShop, alt: "The catalogue with category rail and filters", w: 1920, h: 1200 },
      { kind: "video", src: alwaniMap, poster: alwaniMapPoster, posterAt: 6.3, alt: "Five destinations on one map, each with its tours", w: 1920, h: 1200 },
      { kind: "video", src: alwaniMobileScroll, poster: alwaniMobileScrollPoster, posterAt: 0.5, alt: "The home page on a phone", w: 780, h: 1688 },
      { kind: "image", src: alwaniMobileTour, alt: "A tour page on a phone with the booking bar", w: 780, h: 1688 },
      { kind: "image", src: alwaniTour, alt: "Tour page with photo mosaic and booking card", w: 1920, h: 1200 },
      { kind: "video", src: alwaniBooking, poster: alwaniBookingPoster, posterAt: 13.4, alt: "Picking a date, a package and travellers", w: 1920, h: 1200 },
      { kind: "image", src: alwaniTransfers, alt: "Airport transfers run by Alwani’s own vans and drivers", w: 1920, h: 1200 },
    ],
  },
  {
    id: "dmc",
    title: "Alwani DMC",
    kicker: "B2B site for travel agents",
    year: "2026",
    role: "Sole engineer",
    featured: true,
    summary:
      "The trade side of Alwani Travel: a bilingual site where travel agents and tour operators see what the Phuket team runs on the ground, then send a brief for a costed plan.",
    stats: [
      { value: "5", label: "destinations, drawn on one map as you scroll" },
      { value: "2", label: "languages, English and Thai" },
    ],
    details: [
      "Designed and built the B2B site for travel agencies and tour operators who resell Alwani’s tours, tickets, transfers and group programmes under their own brand.",
      "Told the offer as one scroll story: a headline that plays film through its letters and opens into it, service panels that widen one at a time, and a dotted map that draws the route to each destination.",
      "Turned the quote request into a brief form that writes the message for WhatsApp or email, so an agency can ask for a costed plan without making an account.",
      "Shipped it in English and Thai.",
    ],
    stack: ["Next.js", "GSAP", "Lenis"],
    links: [{ label: "Visit dmc.alwanitravel.com", href: "https://dmc.alwanitravel.com" }],
    cover: { kind: "video", src: dmcHero, small: dmcHeroSmall, poster: dmcHeroPoster, posterAt: 1, alt: "Alwani DMC home page with film playing through the headline We handle Thailand", w: 2880, h: 2120 },
    gallery: [
      { kind: "video", src: dmcExpand, small: dmcExpandSmall, poster: dmcExpandPoster, posterAt: 8.74, alt: "The headline opens into the film, then four service panels widen in turn", w: 2880, h: 1800, span: "wide" },
      { kind: "image", src: dmcGround, alt: "What agents can hold the team to: own vans, a tourism licence, a person on call", w: 1920, h: 1200 },
      { kind: "image", src: dmcProcess, alt: "What happens after an agency sends a brief", w: 1920, h: 1200 },
      { kind: "image", src: dmcMobileHero, alt: "The home page on a phone, in English", w: 780, h: 1688 },
      { kind: "image", src: dmcMobileThai, alt: "The same page in Thai", w: 780, h: 1688 },
      { kind: "video", src: dmcMap, small: dmcMapSmall, poster: dmcMapPoster, posterAt: 9.6, alt: "A dotted map draws the route from Phuket to each destination", w: 2880, h: 1800, span: "wide" },
      { kind: "image", src: dmcReviews, alt: "Reviews from agencies and tour operators", w: 1920, h: 1200 },
      { kind: "image", src: dmcBrief, alt: "The brief form that writes the message for WhatsApp or email", w: 1920, h: 1200 },
    ],
  },
  {
    id: "dbz",
    title: "Dragon Ball NFT Game",
    kicker: "Web3 game",
    summary: "A memory card game where winning cards are minted as NFTs you can trade on OpenSea.",
    details: [
      "Built a memory card game with blockchain integration and NFT minting.",
      "Winning cards land in wallets like MetaMask and are tradable on OpenSea.",
      "Smart contracts handle secure NFT creation and transfers.",
      "UI built with React, Web3.js and Ethers.js.",
    ],
    stack: ["Solidity", "React", "Ethers.js", "Web3.js"],
    links: [
      {
        label: "Read the write-up",
        href: "https://medium.com/@shahfaisalwani14/create-dragon-ball-nft-game-deploy-to-sepolia-testnet-6badfd52b906",
      },
    ],
    cover: { kind: "video", src: dbz1Video, poster: dbz1Poster, alt: "Gameplay of the Dragon Ball memory card game", w: 850, h: 508 },
    gallery: [
      { kind: "video", src: dbz1Video, poster: dbz1Poster, alt: "Gameplay of the memory card game", w: 850, h: 508 },
      { kind: "image", src: dbz2, alt: "Game start screen with wallet connect", w: 720, h: 443 },
      { kind: "image", src: dbz4, alt: "Minted card collection on OpenSea", w: 1600, h: 982, span: "wide" },
      { kind: "image", src: dbz3, alt: "Single minted NFT detail page", w: 720, h: 377 },
    ],
  },
  {
    id: "robox",
    title: "Autonomous Service Robot",
    kicker: "Robotics",
    links: [],
    summary: "A mobile robot that maps a room with LIDAR and plans its own collision-free path.",
    details: [
      "Built autonomous navigation with SLAM on ROS2.",
      "Designed the circuits linking the LIDAR, motors and onboard processor.",
      "Wrote the path planning for collision-free movement.",
    ],
    stack: ["ROS2", "SLAM", "LIDAR", "Circuits"],
    cover: { kind: "image", src: robox1, alt: "The service robot with its LIDAR sensor on top", w: 1000, h: 1333, focus: "50% 50%" },
    gallery: [
      { kind: "image", src: robox5, alt: "Occupancy grid map built by the robot", w: 785, h: 568 },
      { kind: "image", src: robox1, alt: "The robot, side view", w: 1000, h: 1333 },
      { kind: "image", src: robox2, alt: "The robot, top view with LIDAR", w: 1000, h: 1333 },
      { kind: "image", src: robox3, alt: "Odometry geometry for the drive model", w: 1079, h: 701 },
      { kind: "image", src: robox4, alt: "Raw LIDAR scan points", w: 725, h: 520 },
      { kind: "image", src: robox6, alt: "RViz layout", w: 1061, h: 559, span: "wide" },
      { kind: "image", src: robox7, alt: "Navigation goal and costmap in RViz", w: 1024, h: 646 },
    ],
  },
  {
    id: "alphard",
    title: "Andaman Luxury Car",
    kicker: "Chauffeur hire site",
    year: "2026",
    role: "Solo build",
    summary:
      "A Thai and English site for a Phuket chauffeur service with a black Toyota Alphard, told as a scroll film: the car, the island it drives you around, the fares and a form that writes the booking for you.",
    details: [
      "Rebuilt the owner’s 2024 one-pager as a scroll film. The hero opens on the Alphard, then the camera closes in on the sliding door, its window rolls down onto Promthep Cape at dusk, and the view opens out through it to fill the screen.",
      "Sent the island past sideways: a pinned drive past six places, from the airport to Khao Lak, in Phuket footage graded to match the owner’s photos, each place with the trip and fare that reaches it.",
      "Set the fares as an airport arrivals board: trip names on plates and prices on split flaps that flap into place when the board comes into view, and turn to Thai on a language switch.",
      "Replaced the contact step with a trip form that writes the booking message as you fill it in, ready to send by text, copy or call.",
      "Put it on its own domain as two prerendered pages, English and Thai, linked to each other for search, with LocalBusiness structured data. Added Google Analytics with consent and a privacy notice, counting calls and sent bookings as leads. Footage loads only near the screen, can be paused from the nav and stops under reduced motion.",
    ],
    stack: ["React", "TypeScript", "GSAP", "Lenis", "Tailwind CSS"],
    links: [{ label: "Visit andaman-luxury-car.com", href: "https://andaman-luxury-car.com" }],
    cover: { kind: "video", src: alphardHero, small: alphardHeroSmall, poster: alphardHeroPoster, posterAt: 4.2, alt: "Andaman Luxury Car: the Alphard arrives, then the camera goes through its sliding door window onto Promthep Cape", w: 2880, h: 1800 },
    gallery: [
      { kind: "video", src: alphardStepIn, small: alphardStepInSmall, poster: alphardStepInPoster, posterAt: 0.2, alt: "Pushing through the open sliding door into the cabin", w: 2880, h: 1800, span: "wide" },
      { kind: "video", src: alphardFares, poster: alphardFaresPoster, posterAt: 3.2, alt: "The fares board flaps into place, then its plates turn to Thai", w: 1920, h: 1200 },
      { kind: "video", src: alphardBook, poster: alphardBookPoster, posterAt: 0.3, alt: "Filling in a Khao Lak transfer writes the booking message", w: 1920, h: 1200 },
      { kind: "video", src: alphardIsland, small: alphardIslandSmall, poster: alphardIslandPoster, posterAt: 0.3, alt: "A sideways drive past six places on the island, each with its fare", w: 2880, h: 1800, span: "wide" },
      { kind: "video", src: alphardMobileHero, poster: alphardMobileHeroPoster, posterAt: 2.6, alt: "The opening on a phone, through the window and into the cabin", w: 780, h: 1688 },
      { kind: "image", src: alphardMobileFaresThai, alt: "The fares board in Thai on a phone", w: 780, h: 1688 },
      { kind: "image", src: alphardModels, alt: "The two Alphards side by side", w: 1920, h: 1200 },
      { kind: "image", src: alphardFooter, alt: "The footer, with Phuket footage showing through the wordmark", w: 1920, h: 1200 },
    ],
  },
];

/* ------------------------------------------------------------- Toolbox */

export type Tool = { name: string; core?: boolean };

export const toolbox: Tool[] = [
  { name: "TypeScript", core: true },
  { name: "Python", core: true },
  { name: "React", core: true },
  { name: "FastAPI", core: true },
  { name: "Node.js", core: true },
  { name: "Go", core: true },
  { name: "JavaScript" },
  { name: "Next.js" },
  { name: "NestJS" },
  { name: "vLLM" },
  { name: "LiveKit" },
  { name: "Langfuse" },
  { name: "Docker" },
  { name: "Kubernetes" },
  { name: "Azure" },
  { name: "GCP" },
  { name: "AWS" },
  { name: "PostgreSQL" },
  { name: "Redis" },
  { name: "MongoDB" },
  { name: "MySQL" },
  { name: "Spark" },
  { name: "Vue.js" },
  { name: "Solid.js" },
  { name: "Flask" },
  { name: "Nginx" },
  { name: "Linux" },
  { name: "Git" },
  { name: "DigitalOcean" },
  { name: "Solidity" },
  { name: "OpenCV" },
  { name: "ROS2" },
  { name: "Java" },
  { name: "C" },
];

/* --------------------------------------------------------- Recognition */

export type Cert = {
  id: string;
  title: string;
  issuer: string;
  year?: string;
  group: "Academic" | "Competitions" | "Courses";
  /* full scan for the viewer, 640px thumbnail for the wall */
  image: string;
  thumb: string;
  /* intrinsic pixel size of the scan */
  w: number;
  h: number;
};

/* Wall order and the one-line note on each group's cell. */
export const certGroups: { id: Cert["group"]; note: string }[] = [
  { id: "Academic", note: "Degree, GPA awards and international GCSEs." },
  { id: "Competitions", note: "Hackathons, coding contests and maths olympiads." },
  { id: "Courses", note: "Data, AI and event streaming fundamentals." },
];

export const certs: Cert[] = [
  { id: "degree", title: "B.Eng Digital Engineering, Second Class Honours", issuer: "Prince of Songkla University", year: "2025", group: "Academic", image: certDegree, thumb: certDegreeThumb, w: 1100, h: 829 },
  { id: "grade-0", title: "Academic excellence, GPA 3.95", issuer: "PSU College of Computing", year: "2022", group: "Academic", image: certGrade0, thumb: certGrade0Thumb, w: 1100, h: 775 },
  { id: "grade-1", title: "Academic excellence, GPA 3.91", issuer: "PSU College of Computing", year: "2023", group: "Academic", image: certGrade1, thumb: certGrade1Thumb, w: 1100, h: 775 },
  { id: "igcse", title: "Cambridge IGCSE", issuer: "Cambridge Assessment International Education", group: "Academic", image: certIgcse, thumb: certIgcseThumb, w: 1100, h: 1535 },
  { id: "edexel", title: "Edexcel International GCSE", issuer: "Pearson", group: "Academic", image: certEdexel, thumb: certEdexelThumb, w: 1100, h: 1516 },
  { id: "hack-0", title: "HACKaTHAILAND Competition", issuer: "DEPA", year: "2022", group: "Competitions", image: certHack0, thumb: certHack0Thumb, w: 1100, h: 779 },
  { id: "shopee", title: "Shopee Code League", issuer: "Shopee", year: "2022", group: "Competitions", image: certShopee, thumb: certShopeeThumb, w: 1100, h: 778 },
  { id: "ukmt", title: "Senior Mathematical Challenge, Silver", issuer: "UK Mathematics Trust", year: "2020", group: "Competitions", image: certUkmt, thumb: certUkmtThumb, w: 1100, h: 810 },
  { id: "timo", title: "Merit Award, TIMO", issuer: "Thailand International Mathematical Olympiad", year: "2018", group: "Competitions", image: certTimo, thumb: certTimoThumb, w: 1100, h: 774 },
  { id: "gacc", title: "PSU Young GACC", issuer: "Prince of Songkla University", year: "2021", group: "Competitions", image: certGacc, thumb: certGaccThumb, w: 1100, h: 775 },
  { id: "kafka", title: "Apache Kafka for Beginners", issuer: "Udemy", year: "2024", group: "Courses", image: certKafka, thumb: certKafkaThumb, w: 1100, h: 818 },
  { id: "hack-1", title: "Basic AI Course", issuer: "HACKaTHAILAND, DEPA and AIAT", year: "2022", group: "Courses", image: certHack1, thumb: certHack1Thumb, w: 1100, h: 778 },
  { id: "hack-2", title: "Fundamental Data Analytics", issuer: "HACKaTHAILAND, DEPA and AIAT", year: "2021", group: "Courses", image: certHack2, thumb: certHack2Thumb, w: 1100, h: 778 },
];
